import React from 'react'

function VoucherQueue() {
    return (
        <div className="formbold-main-wrapper add-plan-wrapper" style={{paddingBottom:'10px'}}>
                    <div className="formbold-form-wrapper add-plan-form add-plan-head">
                        <h5>Recharge Voucher Queueing</h5> 
                    </div>
        </div>
    )
}

export default VoucherQueue